const firebaseConfig = {
  apiKey: "AIzaSyAKIJEitHzLQwCLK9d8ozLpa8p5kIgkX-A",
  authDomain: "rotors-car-website.firebaseapp.com",
  projectId: "rotors-car-website",
  storageBucket: "rotors-car-website.appspot.com",
  messagingSenderId: "691263817113",
  appId: "1:691263817113:web:23a16dd8bd5a26eb72ff08",
  measurementId: "G-LC59S93V0S"
};

export default firebaseConfig;
